export default {
	EMPTY: 'empty',
	READY: 'ready',
	UPLOADING: 'uploading',
}
